import React from 'react';
import Button from "../../../components/Button";
import ServiceCards from '../../Carrieres/components/ServiceCard';
import ImageIntegration from '../../../ressources/images/vignette_integration.svg'
import ImageExpertise from '../../../ressources/images/vignette_expertise.svg'
import ImageDeveloppement from '../../../ressources/images/vignette_developpement.svg'
import { useTranslation } from 'react-i18next';

export default function Services() {
  const { t } = useTranslation();
  return (
    <div className='mt-20 wrapper xl:mt-20'>
        <h1 data-anchor-title className="text-4xl font-bold text-center md:text-5xl md:mb-20" data-aos="zoom-in">
          {t("service_nos")}
            <span className="text-primOrange"> {t("service_services")}</span> 
        </h1>
        <div className='flex justify-center items-center mt-12 gap-12 flex-wrap'>
          <ServiceCards titre={t("service_expertise")} texte={t("service_expertise_text")} image={ImageExpertise}/>
        </div>
        <div className='flex justify-center items-center mt-12 gap-12 flex-wrap'>
          <ServiceCards titre={t("service_developpement")} texte={t("service_developpement_text")} image={ImageDeveloppement}/>
          <ServiceCards titre={t("service_integration")} texte={t("service_integration_text")} image={ImageIntegration}/>
        </div>
        <div className="flex justify-center mt-9 md:mt-16">
            <Button to="notre-offre" texte={t("service_decouvrir")}/>
        </div>
    </div>
  )
}